import type React from 'react';

import { Grid, type GridProps } from '@mui/material';

export const BodyCenter: React.FC<GridProps> = props => {
  return (
    <Grid
      alignItems="center"
      container
      justifyContent="center"
      sx={{ height: '100%' }}
      {...props}
    />
  );
};
